import type { CSSObject } from "@emotion/react";
import { vars } from "@imwebme/clay-token";
import type { TooltipContentProps } from "./TooltipContent.types";

export const calculatePosition = ({
  position,
  offsetY = "4px",
  offsetX = "0px",
  hasArrow,
}: Pick<TooltipContentProps, "hasArrow" | "offsetX" | "offsetY" | "position">): CSSObject => {
  switch (position) {
    case "top":
      return {
        top: `calc(-${offsetY} ${hasArrow ? "- 6px" : ""} - 4px)`,
        left: "50%",
        transform: "translate(-50%, -100%)",
        "&:after": {
          display: hasArrow ? "block" : "none",
          content: '""',
          position: "absolute",
          bottom: "-5px",
          left: "50%",
          transform: "translateX(-50%)",
          borderTop: `solid 6px ${vars.semantic.color.surface}`,
          borderLeft: "solid 6px transparent",
          borderRight: "solid 6px transparent",
        },
        "&:before": {
          display: hasArrow ? "block" : "none",
          content: '""',
          position: "absolute",
          bottom: "-5.1px",
          left: "50%",
          transform: "translateX(-50%)",
          borderTop: "solid 6.1px rgba(75, 81, 91, 0.03)",
          borderLeft: "solid 6.1px transparent",
          borderRight: "solid 6.1px transparent",
        },
      };

    case "bottom":
      return {
        bottom: `calc(-${offsetY} ${hasArrow ? "- 6px" : ""} - 4px)`,
        left: "50%",
        transform: "translate(-50%, 100%)",
        "&:after": {
          display: hasArrow ? "block" : "none",
          content: '""',
          position: "absolute",
          top: "-5px",
          left: "50%",
          transform: "translateX(-50%)",
          borderBottom: `solid 6px ${vars.semantic.color.surface}`,
          borderLeft: "solid 6px transparent",
          borderRight: "solid 6px transparent",
        },
        "&:before": {
          display: hasArrow ? "block" : "none",
          content: '""',
          position: "absolute",
          top: "-5.1px",
          left: "50%",
          transform: "translateX(-50%)",
          borderBottom: "solid 6.1px rgba(75, 81, 91, 0.03)",
          borderLeft: "solid 6.1px transparent",
          borderRight: "solid 6.1px transparent",
        },
      };

    case "top-right":
      return {
        top: `calc(-${offsetY} ${hasArrow ? "- 6px" : ""} - 4px)`,
        right: `calc(${offsetX} + 15px)`,
        transform: "translate(100%, -100%)",
        "&:after": {
          display: hasArrow ? "block" : "none",
          content: '""',
          position: "absolute",
          bottom: "-5px",
          left: "15px",
          transform: "translateX(-50%)",
          borderTop: `solid 6px ${vars.semantic.color.surface}`,
          borderLeft: "solid 6px transparent",
          borderRight: "solid 6px transparent",
        },
        "&:before": {
          display: hasArrow ? "block" : "none",
          content: '""',
          position: "absolute",
          bottom: "-5.1px",
          left: "15px",
          transform: "translateX(-50%)",
          borderTop: "solid 6.1px rgba(75, 81, 91, 0.03)",
          borderLeft: "solid 6.1px transparent",
          borderRight: "solid 6.1px transparent",
        },
      };

    case "bottom-right":
      return {
        bottom: `calc(-${offsetY} ${hasArrow ? "- 6px" : ""} - 4px)`,
        right: 0,
        transform: "translate(0, 100%)",
        "&:after": {
          display: hasArrow ? "block" : "none",
          content: '""',
          position: "absolute",
          top: "-5px",
          right: 0,
          transform: "translateX(-50%)",
          borderBottom: `solid 6px ${vars.semantic.color.surface}`,
          borderLeft: "solid 6px transparent",
          borderRight: "solid 6px transparent",
        },
        "&:before": {
          display: hasArrow ? "block" : "none",
          content: '""',
          position: "absolute",
          top: "-5.1px",
          right: 0,
          transform: "translateX(-50%)",
          borderBottom: "solid 6.1px rgba(75, 81, 91, 0.03)",
          borderLeft: "solid 6.1px transparent",
          borderRight: "solid 6.1px transparent",
        },
      };

    case "left":
      return {
        top: "50%",
        transform: "translate(-100%,-50%)",
        left: `calc(-${offsetX} ${hasArrow ? "- 6px" : ""} - 4px)`,
        "&:after": {
          display: hasArrow ? "block" : "none",
          content: '""',
          position: "absolute",
          right: "-5px",
          top: "50%",
          transform: "translateY(-50%)",
          borderBottom: "solid 6px transparent",
          borderTop: "solid 6px transparent",
          borderLeft: `solid 6px ${vars.semantic.color.surface}`,
        },
        "&:before": {
          display: hasArrow ? "block" : "none",
          content: '""',
          position: "absolute",
          right: "-5.1px",
          top: "50%",
          transform: "translateY(-50%)",
          borderBottom: "solid 6.1px transparent",
          borderTop: "solid 6.1px transparent",
          borderLeft: "solid 6.1px rgba(75, 81, 91, 0.03)",
        },
      };

    // right
    default:
      return {
        top: "50%",
        transform: "translate(100%,-50%)",
        right: `calc(-${offsetX} ${hasArrow ? "- 6px" : ""} - 4px)`,
        "&:after": {
          display: hasArrow ? "block" : "none",
          content: '""',
          position: "absolute",
          left: "-5px",
          top: "50%",
          transform: "translateY(-50%)",
          borderBottom: "solid 6px transparent",
          borderTop: "solid 6px transparent",
          borderRight: `solid 6px ${vars.semantic.color.surface}`,
        },
        "&:before": {
          display: hasArrow ? "block" : "none",
          content: '""',
          position: "absolute",
          left: "-5.1px",
          top: "50%",
          transform: "translateY(-50%)",
          borderBottom: "solid 6.1px transparent",
          borderTop: "solid 6.1px transparent",
          borderRight: "solid 6.1px rgba(75, 81, 91, 0.03)",
        },
      };
  }
};
